import styled from "styled-components";

type ContainerMoveScrollToFinal = {
    background: string
    isDarkTheme: boolean
}

export const ContainerButtonMoveScrollToBottom = styled.div<ContainerMoveScrollToFinal>`
  z-index: 100;
  position: absolute;
  right: 20px;
  bottom: 100px;
  display: flex;
  height: 42px;
  width: 42px;
  border-radius: 50%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background: ${props => props.background};

  &:hover {
    filter: brightness(80%);
  }
`;